export const quotes = [
  {
    content:
      "Age is an issue of mind over matter. If you don't mind, it doesn't matter.",
    author: "Mark Twain",
  },
  {
    content:
      "Anyone who stops learning is old, whether at twenty or eighty. Anyone who keeps learning stays young. The greatest thing in life is to keep your mind young.",
    author: "Henry Ford",
  },
  {
    content: "Wrinkles should merely indicate where smiles have been.",
    author: "Mark Twain",
  },
  {
    content:
      "True terror is to wake up one morning and discover that your high school class is running the country.",
    author: "Kurt Vonnegut",
  },
  {
    content:
      "As I grow older, I pay less attention to what men say. I just watch what they do.",
    author: "Andrew Carnegie",
  },
  {
    content:
      "How incessant and great are the ills with which a prolonged old age is replete.",
    author: "C. S. Lewis",
  },
  {
    content:
      "Old age, believe me, is a good and pleasant thing. It is true you are gently shouldered off the stage, but then you are given such a comfortable front stall as spectator.",
    author: "Confucius",
  },
  {
    content:
      "Old age has deformities enough of its own. It should never add to them the deformity of vice.",
    author: "Eleanor Roosevelt",
  },
  {
    content:
      "Nobody grows old merely by living a number of years. We grow old by deserting our ideals. Years may wrinkle the skin, but to give up enthusiasm wrinkles the soul.",
    author: "Samuel Ullman",
  },
];
